export default {
  unmute: 'Unmute',
  mute: 'Mute',
  keypad: 'Keypad',
  hold: 'Hold',
  onHold: 'On Hold',
  park: 'Park',
  stopRecord: 'Stop',
  record: 'Record',
  add: 'Add',
  transfer: 'Transfer',
  flip: 'Flip',
  more: 'Call Actions',
  mergeToConference: 'Merge',
  end: 'End',
  completeTransfer: 'Complete\nTransfer',
} as const;
